export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5010.08ee6764.jpg";